export const RETRY_FETCH = 'giftCertificates/RETRY_FETCH';
